export default __webpack_public_path__ + "static/toit_logo-ee1b790ef53ae6c8186fe1a9bd28693b.svg";